/* eslint-disable no-unused-vars */
import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Typography, Modal, FormControl, TextField, IconButton, MenuItem, Select } from "@mui/material";
import CustomButton from "../../components/buttons/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import MessageIcon from "../../../assets/images/messageIcon.svg";
import { SelectedAlertsContext } from "../../../utils/SelectedAlertContext";
import styles from "./popup.module.css";
import { buyerComment,factoryComment } from "Samarth Module/api/mdApi";
import { useMsal } from "@azure/msal-react";

const CommentsPopup = ({ open, onClose, alertId, type, onConfirm }) => {
    const factoryCommentsOptions = [
        "Material In-transit",
        "Material in GR/Unloading",
        "Plan change/Schedule change",
        "JIT Material",
        "Contract related (FSI Issue)",
        "Contract related (SOB Issue)",
        "Contract related (Incorrect qty)",
        "Contract related (Expiry issue)",
        "Contract related (Pricing issue)",
        "Supplier issue (Dispatch details pending)",
        "Supplier issue (Capacity constraint/Quality issue)",
        "PO related (MOQ issue)",
        "Factory related (Wrong BOM/PV selected)",
        "Factory related (Wrong/Inactive material)",
        "Vendor related (Truck placement issue at Vendor location)"
    ];
     const { accounts } = useMsal();
    const activeAccount = accounts[0] || null;
    const { setAlertDetailsData } = useContext(SelectedAlertsContext);
    const [feedback, setFeedback] = useState("");

    // handling the submit for the feeedback for other Recommendation
    const handleSubmitFeedback = async (alertId) => {
        if (type === 'RMPM Alert') {
            try {
                // API call for saving the feedback other recommendation
                const payload = {
                    "alertId": alertId["Alert ID"],
                    "plant": alertId['Site code'],
                    "type": type,
                }
                if (type === 'RMPM Alert') {
                    payload["materialId"] = alertId['Material Id'];
                    payload["week"] = parseInt(alertId['Week'].split('Week ')[1]);
                    payload["Material Group"] = alertId['Material Group'];
                    payload["Material Group Description"] = alertId['Material Group Description'];
                }
                if (alertId['Label']==='Buyer Comments'){
                    await buyerComment({...payload,'Alert':alertId,'comment':feedback,'username':activeAccount.username})
                    setAlertDetailsData((prevData) =>
                    prevData.map((item) => {
                        if (item["Alert ID"] !== alertId["Alert ID"]) return item;
                        return {
                            ...item,
                            BuyerComments:feedback
                        };
                    }));
                }
                else if (alertId['Label']==='Factory Comments'){
                    await factoryComment({...payload,'Alert':alertId,'comment':feedback,'username':activeAccount.username})
                    setAlertDetailsData((prevData) =>
                    prevData.map((item) => {
                        if (item["Alert ID"] !== alertId["Alert ID"]) return item;
                        return {
                            ...item,
                            FactoryComments:feedback
                        };
                    }));
                }
                

                if (onConfirm) onConfirm(feedback);
            } catch (error) {
                console.error("Error executing actions:", error);
            } finally {
                setFeedback('')
                onClose();
            }
        }
    };

    // for closing the feedback popup
    const CancelFeedbackPopup = () => {
        onClose();
    };

    // handling input change
    const handleCustomRecommendation = (event) => {
        setFeedback(event.target.value);
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox}>
                    {/* header & close btn */}
                    <div className={styles.dialogBoxContent}>
                        <img src={MessageIcon} alt="Message icon" />
                        <div className={styles.rejectContainer}>
                            <Typography className={styles.header}>{alertId['Label']}</Typography>
                            <IconButton onClick={onClose}>
                                <CloseIcon className={styles.closeIcon} />
                            </IconButton>
                        </div>
                    </div>
                    {alertId['Label'] === 'Buyer Comments' ? (
                        <FormControl style={{ width: '100%' }}>
                            <TextField
                                size="small"
                                autoFocus={true}
                                autoComplete="off"
                                value={feedback}
                                onChange={handleCustomRecommendation}
                                placeholder="Please specify"
                                inputProps={{
                                    style: { fontSize: "12px", width: '100%' },
                                }}
                            />
                        </FormControl>) :
                        (<Select
                            value={feedback}
                            onChange={handleCustomRecommendation}
                            size="small"
                            className={styles.rejectedDropdown}
                        >
                            {factoryCommentsOptions.map((option) => (
                                <MenuItem className={styles.listItem} key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                        )}
                    {/* Submit and cancel buttons for feedback popup */}
                    <div className={`${styles.dialogBtn} ${styles.marginTopBtns}`}>
                        <CustomButton label="Cancel" type="popupCancel" onClick={CancelFeedbackPopup} />
                        <CustomButton label="Submit" disabled={!feedback} type="reject" onClick={() => handleSubmitFeedback(alertId)} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

CommentsPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    alertId: PropTypes.shape({
        "Alert ID": PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        "Site code": PropTypes.string,
        "Material Id": PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        Week: PropTypes.string,
        "Material Group": PropTypes.string,
        "Material Group Description": PropTypes.string,
        Label: PropTypes.string,
    }).isRequired,
    type: PropTypes.string,
    onConfirm: PropTypes.func,
};

export default CommentsPopup;